import { IServicePluginManager } from '../service_plugin/interface';
import { EN_STANDARD_BRANCH_NAMESPACE, ISymbol } from '../types/interface';
import { getStandardBranchContainer } from '../factory';
import { IUIPluginManager } from '../ui_plugin';
import { ServicePluginManager } from '../service_plugin/service_plugin_manager';
import { UIPluginManager } from '../ui_plugin/ui_plugin_manager';
import { EN_SOLUTION_BUSINESS_TYPE } from '@do-lib/global-config-2d';

export interface IStandardBranchBasicData {
  standardBranchId: string;
  standardBranchName: string;
  solutionBusinessType: EN_SOLUTION_BUSINESS_TYPE;
}

export interface ITenantBasicData {
  tenantName: string;
  spaceRelTenantId: string;
}

export class StandardBranchManager {
  public servicePluginManager: IServicePluginManager;

  public UIPluginManager: IUIPluginManager;

  private _standardBranchId = '';

  private _standardBranchName = '';

  private _spaceRelTenantId = '';

  private _tenantName = '';

  private _solutionBusinessType: EN_SOLUTION_BUSINESS_TYPE = EN_SOLUTION_BUSINESS_TYPE.CAD;

  public get standardBranchId(): string {
    return this._standardBranchId;
  }

  public get standardBranchName(): string {
    return this._standardBranchName;
  }

  public get tenantName(): string {
    return this._tenantName;
  }

  public get spaceRelTenantId(): string {
    return this._spaceRelTenantId;
  }

  public get solutionBusinessType(): EN_SOLUTION_BUSINESS_TYPE {
    return this._solutionBusinessType;
  }

  constructor() {
    this.servicePluginManager = new ServicePluginManager();
    this.UIPluginManager = new UIPluginManager();
  }

  public initTenant({ tenantName, spaceRelTenantId }: ITenantBasicData): void {
    // 切换企业需要把品系置空
    this._tenantName = tenantName;
    this._spaceRelTenantId = spaceRelTenantId;
    this._standardBranchId = '';
    this._standardBranchName = '';
  }

  public initStandardBranch({
    standardBranchId,
    standardBranchName,
    solutionBusinessType,
  }: IStandardBranchBasicData): void {
    this._standardBranchId = standardBranchId;
    this._standardBranchName = standardBranchName;
    this._solutionBusinessType = solutionBusinessType;
  }

  /**
   * 注册插件资源
   * @param namespace 插件命名空间
   * @param symbol 插件功能含义
   * @param description 插件描述
   * @param bMulti 插件是否允许多次注册,false会删除symbol或namespace相同的,默认为true
   * @returns
   */
  public register(
    namespace: EN_STANDARD_BRANCH_NAMESPACE,
    symbol?: ISymbol,
    description?: string,
    bMulti = true
  ) {
    return (value: any): void => {
      const container = getStandardBranchContainer();
      if (!bMulti && container.isBound(namespace as EN_STANDARD_BRANCH_NAMESPACE, symbol)) {
        container.unRegister(namespace as EN_STANDARD_BRANCH_NAMESPACE, symbol);
      }

      if (namespace === undefined || namespace === EN_STANDARD_BRANCH_NAMESPACE.DEFAULT) {
        container.register({ namespace, value, description });
      } else if (namespace === EN_STANDARD_BRANCH_NAMESPACE.SERVICE_PLUGIN) {
        this.servicePluginManager.register(symbol, value, description);
      } else if (namespace === EN_STANDARD_BRANCH_NAMESPACE.UI_PLUGIN) {
        this.UIPluginManager.register(symbol, value, description);
      } else {
        throw new Error(`${namespace}还未实现`);
      }
    };
  }

  public clear(): void {
    const container = getStandardBranchContainer();
    container.clear();
  }
}
